// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__32gR0","password":"PasswordResetForm_password__2jArB"};